// Some dev hosts do not expose the Clipboard API. Keep a user-initiated fallback.
export async function copyText(text) {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Permission or browser restrictions may still allow the copy command.
    }
  }

  if (typeof document === "undefined" || typeof document.execCommand !== "function") {
    throw new Error("Clipboard is unavailable");
  }

  const focused = document.activeElement;
  const selection = document.getSelection();
  const ranges = selection
    ? Array.from({ length: selection.rangeCount }, (_, index) => selection.getRangeAt(index).cloneRange())
    : [];
  const inputSelection = typeof focused?.selectionStart === "number"
    ? [focused.selectionStart, focused.selectionEnd, focused.selectionDirection]
    : null;
  const field = document.createElement("textarea");
  field.value = text;
  field.readOnly = true;
  field.tabIndex = -1;
  field.setAttribute("aria-hidden", "true");
  Object.assign(field.style, { position: "fixed", top: "0", left: "0", opacity: "0", fontSize: "16px" });
  document.body.appendChild(field);

  try {
    field.focus({ preventScroll: true });
    field.select();
    field.setSelectionRange(0, text.length);
    if (!document.execCommand("copy")) throw new Error("Copy command failed");
  } finally {
    field.remove();
    // Copying should not leave focus or text selection on the temporary field.
    try {
      focused?.focus({ preventScroll: true });
      if (inputSelection) focused.setSelectionRange(...inputSelection);
      else if (selection) {
        selection.removeAllRanges();
        ranges.forEach((range) => selection.addRange(range));
      }
    } catch {
      // A disappearing focus target must not turn a successful copy into an error.
    }
  }
}
